import { useForm, type DefaultValues, type FieldValues } from "react-hook-form";
import { useConfirmUnsavedChanges } from "./FormLayout";

// GATE-01-A (agent-logs/runs/2026-09-11-spec-219-offers/evidence/
// human-resolution-gate-01-dup-and-format.json): `useForm({ defaultValues })`
// seguido de `useConfirmUnsavedChanges(isDirty)` y la misma desestructuración
// (`register, handleSubmit, watch, setValue, formState: { errors, isDirty },
// setError`) era el mismo código palabra por palabra en `BenefitEditor` y
// `RewardEditor`. Un hook propio no es más que una función que llama a otros
// hooks en el mismo orden relativo — llamar a `useForm` y
// `useConfirmUnsavedChanges` acá adentro, en vez de en el componente, no
// cambia cuándo ni con qué valor se ejecutan. Extracción sin cambio de
// comportamiento: mismas propiedades devueltas, mismo `isDirty` observado.
export function useEditorForm<T extends FieldValues>(
  defaultValues: DefaultValues<T>,
) {
  const { register, handleSubmit, watch, setValue, formState, setError } =
    useForm<T>({ defaultValues });
  useConfirmUnsavedChanges(formState.isDirty);
  return {
    register,
    handleSubmit,
    watch,
    setValue,
    errors: formState.errors,
    isDirty: formState.isDirty,
    setError,
  };
}
